module.exports = __webpack_public_path__ + "static/008-4085d4c658217ff481e74adc9f0f59f5.jpg";